import DateProvider from './DateProvider';

export default DateProvider;
